export default class ClassicQuizUserParticipation {
  public classicQuizId: string = null;
  public correct: number = null;
  public classicQuizQuestions: number = null;
}
